(function () {
  'use strict';

  if (window.__lpEditorialMiniCartBound) return;
  window.__lpEditorialMiniCartBound = true;

  var busy = false;
  var SPINNER_HTML =
    '<span class="product-buy-buttons--spinner" aria-hidden="true">' +
    '<svg class="icon--root icon--spinner"><use href="#loading-spinner" xlink:href="#loading-spinner"></use></svg>' +
    '</span>';

  function isEnabled() {
    return !!document.querySelector('[data-lp-mini-cart="true"]');
  }

  function parseCartPermalink(href) {
    if (!href || typeof href !== 'string') return null;

    if (href.indexOf('/cart/') === -1 && href.indexOf('%2Fcart%2F') === -1) {
      return null;
    }

    try {
      var url = new URL(href, window.location.origin);
      var pathname = decodeURIComponent(url.pathname);
      var match = pathname.match(/\/cart\/((?:\d+:\d+)(?:,\d+:\d+)*)\/?$/);
      if (!match) return null;

      var items = match[1]
        .split(',')
        .map(function (pair) {
          var parts = pair.split(':');
          return {
            id: parseInt(parts[0], 10),
            quantity: parseInt(parts[1] || '1', 10)
          };
        })
        .filter(function (item) {
          return item.id > 0 && item.quantity > 0;
        });

      if (!items.length) return null;

      return {
        items: items,
        discount: url.searchParams.get('discount')
      };
    } catch (e) {
      return null;
    }
  }

  function applyDiscount(code) {
    if (typeof window.applyPromoDiscountCodes === 'function') {
      return window.applyPromoDiscountCodes(code);
    }
    if (!code) return Promise.resolve(true);
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: String(code) })
    })
      .then(function (r) {
        return r.ok;
      })
      .catch(function () {
        return false;
      });
  }

  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) {
          throw new Error(
            (data && (data.description || data.message)) || 'cart add failed'
          );
        }
        return data;
      });
    });
  }

  function syncCartCounts(count) {
    if (typeof count !== 'number') return;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.setAttribute('data-cart-count', String(count));
    });
  }

  function syncCountsFromBasket() {
    if (typeof theme === 'undefined' || !theme.cart || !theme.cart.basket) return;
    if (typeof theme.cart.displayItemCount === 'number') {
      syncCartCounts(theme.cart.displayItemCount);
      return;
    }
    var count = 0;
    var basket = theme.cart.basket;
    Object.keys(basket).forEach(function (id) {
      count += parseInt(basket[id], 10) || 0;
    });
    syncCartCounts(count);
  }

  function openDrawer() {
    if (
      typeof theme !== 'undefined' &&
      theme.settings &&
      theme.settings.cart_type === 'drawer' &&
      theme.drawer &&
      typeof theme.drawer.open === 'function'
    ) {
      theme.drawer.open('right', 'cart-drawer');
    }
  }

  function refreshCartInBackground(cartResponse) {
    if (typeof theme === 'undefined' || !theme.cart) return Promise.resolve();

    // Totals first (fast) so badge + drawer totals update quickly.
    return theme.cart
      .fetchTotals()
      .then(function () {
        syncCountsFromBasket();
        if (typeof window.trigger === 'function') {
          window.trigger('theme:cart:productAdded', { detail: cartResponse });
        }
      })
      .then(function () {
        // Heavier HTML swap — do not block the loading state.
        return theme.cart.updateAllHtml(true);
      })
      .catch(function () {});
  }

  function ensureSpinner(link) {
    if (!link) return;
    link.classList.add('lp-cart-atc');

    if (link.querySelector('.product-buy-buttons--spinner')) return;

    if (!link.querySelector('.lp-editorial-btn__label')) {
      var label = document.createElement('span');
      label.className = 'lp-editorial-btn__label';
      while (link.firstChild) {
        label.appendChild(link.firstChild);
      }
      link.appendChild(label);
    }

    link.insertAdjacentHTML('beforeend', SPINNER_HTML);
  }

  function clearSpinner(link) {
    if (!link) return;
    link.querySelectorAll('.product-buy-buttons--spinner').forEach(function (el) {
      el.remove();
    });
  }

  function setLinkBusy(link, isBusy) {
    if (!link) return;
    if (isBusy) {
      ensureSpinner(link);
      link.setAttribute('aria-busy', 'true');
      link.setAttribute('data-lp-cart-busy', 'true');
      return;
    }

    clearSpinner(link);
    link.setAttribute('aria-busy', 'false');
    link.removeAttribute('data-lp-cart-busy');
  }

  function handleCartPermalink(link, parsed) {
    if (busy) return;
    busy = true;
    setLinkBusy(link, true);

    // Add + discount in parallel — was sequential and felt slow.
    Promise.all([addItems(parsed.items), applyDiscount(parsed.discount)])
      .then(function (results) {
        var cartResponse = results[0];

        // Open drawer as soon as add succeeds; refresh continues in background.
        openDrawer();
        setLinkBusy(link, false);
        busy = false;

        refreshCartInBackground(cartResponse);
      })
      .catch(function (err) {
        busy = false;
        setLinkBusy(link, false);
        if (typeof console !== 'undefined' && console.error) {
          console.error('lp editorial mini cart failed', err);
        }
      });
  }

  function onClick(event) {
    if (!isEnabled()) return;
    if (event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var link =
      event.target && event.target.closest
        ? event.target.closest('a[href]')
        : null;
    if (!link) return;

    if (
      link.classList.contains('header--cart') ||
      link.hasAttribute('data-drawer-open')
    ) {
      return;
    }

    if (link.getAttribute('aria-busy') === 'true') {
      event.preventDefault();
      return;
    }

    var href = link.getAttribute('href') || '';
    var parsed = parseCartPermalink(href);
    if (!parsed) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    handleCartPermalink(link, parsed);
  }

  function rebindDrawerTriggers() {
    if (
      typeof theme !== 'undefined' &&
      theme.drawer &&
      typeof theme.drawer.loadTriggers === 'function'
    ) {
      try {
        theme.drawer.loadTriggers();
      } catch (e) {}
    }
  }

  document.addEventListener('click', onClick, true);

  document.addEventListener('shopify:section:load', function () {
    if (isEnabled()) rebindDrawerTriggers();
  });
})();
